// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5ebe44c9","532":"83888503"}[chunkId] + ".chunk.js";
};